import { render } from "./grupolistadoinformacion.vue?vue&type=template&id=1097ea36&scoped=true"
import script from "./grupolistadoinformacion.vue?vue&type=script&lang=js"
export * from "./grupolistadoinformacion.vue?vue&type=script&lang=js"

import "./grupolistadoinformacion.vue?vue&type=style&index=0&id=1097ea36&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1097ea36"]])

export default __exports__